import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageJwtService } from '@core/services/localstoragejwt.service';
import { map, take } from 'rxjs';

export const authGuard = () => {
    const router = inject(Router);
    const storage = inject(LocalStorageJwtService);

    const token = storage.getItem();

    if (!token) {
        router.navigate(['sign-in']);
        return false;
    }
    return true;
};
